import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Bootstrap } from './Bootstrap';
import { SignInRoutes } from './Routes/SignInRoutes';
import { AppRoutes } from './Routes/AppRoutes';
import { ErrorRoutes } from './Routes/ErrorRoutes';
import { AppLoading } from '../AppLoading';

export function Router() {
  const router = createBrowserRouter([
    { Component: Bootstrap, children: [...SignInRoutes(), ...AppRoutes(), ...ErrorRoutes()] },
  ]);

  return <RouterProvider router={router} fallbackElement={<AppLoading />} />;
}
